const {Backbone, _} = require('backboneAdapter');
import Handlebars from 'handlebars';
import Template from 'js/templates/message.row.hbs';
import EmailTemplate from 'js/templates/email.preview.template.htm';
import i18n from 'l10n';
require('interfaceAdapter');
require('metroHint2');

export default Backbone.View.extend({
    tagName: 'div',
    className: '',
    template: Handlebars.compile(Template),
    EmailTemplate: Handlebars.compile(EmailTemplate),
    initialize: function () {
        this.model.bind('change', this.render, this);
        this.model.bind('destroy', this.remove, this);
        this.model.get("subscription").bind("toggleBounced", this.render, this);
    },
    events: {
        'click .showEmail': 'showEmail'
    },
    showEmail: function () {
        const self = this;
        $.Dialog({
            overlay: true,
            shadow: true,
            icon: '<span class="icon  icon-tellody-message" style="color:white"></span>',
            title: `Tellody Email - ${String(Handlebars.helpers.timestamp(this.model.get("sentDate"), "L HH:mm"))}`,
            draggable: true,
            height: 'auto',
            position: ['center', 'center'],
            content: '',
            padding: 0,
            onShow: function () {
                self.renderEmail();
            }
        });
    },
    renderEmail: function () {
        //needed to load static files
        const host = "//" + window.location.host;


        const subject = this.model.get("subject");
        const message = this.model.get("message");
        this.collectionEmailTemplate = Handlebars.compile(EmailTemplate)({
            "subjectEmail": subject,
            "messageEmail": message
        });
        const content = $($.Metro.METRO_DIALOG.children(".content"));
        content.html(this.collectionEmailTemplate);
        const emailSubject = subject ? subject : i18n.t("message.nonamemessage");
        let htmlString = message;
        //set all links to open in a new tab
        htmlString = htmlString.replace(/<a/g, "<a target='_blank'");

        //REGEX FUN :) ~ get the body html string, get the body's style attribute and the style scripts from head.
        const body = /<body([^>]*)>([\s\S]*)<\/body>/gi.exec(htmlString);
        const styles = htmlString.match(/<style[^>]*>[\s\S]*?<\/style>/gi);

        const $ifrDoc = $('iframe').contents();
        const $ifrBody = $ifrDoc.find('body');
        if (styles) {
            _.each(styles, function (stTag) {
                $(stTag).appendTo('head');
            });
            const styleAttr = /style\s*=\s*?(['"])([\s\S]*?)\1/gi.exec(body[1]);
            $ifrBody.attr('style', styleAttr[2]);
        }
        $ifrBody.append('<h2 style="padding-bottom:10px; margin-bottom:10px; ' +
            'border: 1px lightgray;border-bottom-style: solid;word-wrap: break-word;">' +
            emailSubject + '</h2>');
        $ifrBody.append('<div style="word-wrap: break-word;">' + (body ? body[2] : htmlString) + '</div>');
        $ifrDoc.find('img').each(function () {
            const src = $(this).attr('src');
            if (src && src.match(/tellody\.com\/u\//)) {
                $(this).attr('src', host + '/CampaignCloud/resources/images/tellody-logo-20px.png');
            } else {
                const content = src.replace('cid:', '');
                if (content.startsWith("MOS.")) {
                    const comps = content.split('.');
                    comps.shift();
                    const mosTemplate = comps.shift();
                    const ext = comps.pop();
                    const fname = comps.pop();
                    const path = comps.length ? comps.join('/') + '/' : '';
                    $(this).attr('src', `${host}/CampaignCloud/mosaico/templates/${mosTemplate}/img/${path}${fname}.${ext}`);
                }
                else if (content.startsWith("TEL.")) {
                    $(this).attr('src', host + '/CampaignCloud/cloudui/img/' + content.replace("TEL.", ""));
                }
                else if (content.length === 24) {
                    $(this).attr('src', host + '/CampaignCloud/Content/LoadFileContentBytes/' + content);
                }
                else if (!content.includes('/CampaignCloud/cloudui/img/')) {
                    const urlQuery = content.replace(/\./, "?").replace(/\./g, "&").replace(/_/g, "=");
                    $(this).attr('src', host + '/CampaignCloud/mosaico/img/' + urlQuery);
                }
            }
        });
        const $window = $('.window.shadow');
        $window.css("height", "auto");
        $window.css("top", "15px");
        this.$('[data-i18n]').i18n();

        //$('iframe').attr("src", "data:text/html;charset=utf-8,"+ $ifrBody.html())
    },
    render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        this.$el.addClass("bg-transparent");
        return this;
    }
});
